import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonDropdownComponent} from '../common-dropdawn/common-dropdown.component';
import {FormControl} from '@angular/forms';
import {Params} from '@angular/router';
import {PersonSelectorService} from '../../services/person-selector.service';

@Component({
    selector: 'app-person-selector',
    standalone: true,
    imports: [CommonModule, CommonDropdownComponent],
    templateUrl: './person-selector.component.html',
    styleUrl: './person-selector.component.scss'
})
export class PersonSelectorComponent implements OnInit, OnChanges{
    @Input({ required: true }) formCtrl!: FormControl;
    @Input() label: string | undefined;
    @Input() additionalParams?: Params; // здесь можно будет задать фильтра для конкретной компании
    @Input() disabled = false;

    constructor(protected personSelectorService: PersonSelectorService) {}

    ngOnInit(): void {
        this.updateAdditionalParams();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['additionalParams']) {
            this.updateAdditionalParams();
        }
    }

    private updateAdditionalParams(): void {
        if (this.additionalParams) {
            this.personSelectorService.additionalParams = this.additionalParams;
        }
    }
}
